export interface Card {
  id: number;
  type: 'visa' | 'mastercard' | 'maestro';
  name: string;
  bank: string;
  isMain: boolean;
  isActive: boolean;
  expirationDate: string | null;
}

export const cards: Card[] = [
  {
    id: 1,
    type: 'mastercard',
    name: 'My new card wwwwwas asasjashdh jsadjsahd jkhsajd',
    bank: 'Unibank',
    isMain: true,
    isActive: true,
    expirationDate: null,
  },
  {
    id: 2,
    type: 'visa',
    name: 'Visa •• 6263',
    bank: 'Unibank',
    isMain: false,
    isActive: true,
    expirationDate: null,
  },
  {
    id: 3,
    type: 'maestro',
    name: 'Maestro •• 1731',
    bank: 'Unibank',
    isMain: false,
    isActive: false,
    expirationDate: '12/22',
  },
  {
    id: 4,
    type: 'maestro',
    name: 'Maestro •• 1731',
    bank: 'Unibank',
    isMain: false,
    isActive: false,
    expirationDate: null,
  },
];
